export const queryKeys = {
  pickem: {
    all: ['pickem'] as const,
    lists: () => [...queryKeys.pickem.all, 'list'] as const,
    list: (filters: any) => [...queryKeys.pickem.lists(), filters] as const,
    details: () => [...queryKeys.pickem.all, 'detail'] as const,
    detail: (id: string, location?: string) =>
      [...queryKeys.pickem.details(), id, location] as const,
    upcoming: (location?: string) => [...queryKeys.pickem.all, 'upcoming', location] as const,
    recent: (location?: string) => [...queryKeys.pickem.all, 'recent', location] as const,
    today: (location?: string) => [...queryKeys.pickem.all, 'today', location] as const,
    play: (location?: string) => [...queryKeys.pickem.all, 'play', location] as const,
    rules: (id: string) => [...queryKeys.pickem.all, 'rules', id] as const,
  },
  tenant: {
    all: ['tenant'] as const,
    lists: () => [...queryKeys.tenant.all, 'list'] as const,
    list: (filters: any) => [...queryKeys.tenant.lists(), filters] as const,
    details: () => [...queryKeys.tenant.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.tenant.details(), id] as const,
  },
  leaderboard: {
    all: ['leaderboard'] as const,
    pickem: (id: string) => [...queryKeys.leaderboard.all, 'pickem', id] as const,
    global: (period: string) => [...queryKeys.leaderboard.all, 'global', period] as const,
  },
  user: {
    all: ['user'] as const,
    details: () => [...queryKeys.user.all, 'details'] as const,
    raffles: () => [...queryKeys.user.all, 'raffles'] as const,
    streak: () => [...queryKeys.user.all, 'streak'] as const,
  },
};
